import { IBackendCartEntries, ICartEntry } from '@rbi-ctg/menu';
import { ICartEntryFragment } from 'generated/rbi-graphql';
import { useSwitchCartMethodDialog } from 'hooks/use-switch-cart-method-dialog';
import { useLocationContext } from 'state/location';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { useOrderContext } from 'state/order';
import { useStoreContext } from 'state/store';
import { routes } from 'utils/routing';

interface UseAddToCartProps {
  cartEntry: ICartEntry | IBackendCartEntries | ICartEntryFragment | null;
  mParticleEvent?: CustomEventNames;
  mParticleUserLocation?: string;
}

const useAddToCartRecentItem = ({
  cartEntry,
  mParticleEvent,
  mParticleUserLocation,
}: UseAddToCartProps) => {
  const mParticle = useMParticleContext();
  const { location, setStoreLocatorCallbackUrl, navigate } = useLocationContext();
  const {
    addToCart: addItemToCart,
    recent: {
      setPendingRecentItem,
      pendingRecentItemNeedsReprice,
      setPendingRecentItemNeedsReprice,
    },
    repriceCartEntries,
  } = useOrderContext();
  const { isStoreOpenAndAvailable } = useStoreContext();
  const {
    SwitchCartMethodDialog,
    openSwitchCartMethod,
    shouldShowSwitchToMobileDialog,
  } = useSwitchCartMethodDialog();

  const handleAddToCart = () => {
    if (isStoreOpenAndAvailable) {
      if (mParticleEvent) {
        mParticle.logEvent(mParticleEvent, EventTypes.UserContent, {
          'Product Name': cartEntry?.name,
          'User Location': mParticleUserLocation,
        });
      }
      // If you had no store selected previously the prices on the cartEntry are zero
      // This will repair the prices before adding to cart
      if (pendingRecentItemNeedsReprice) {
        const [repricedEntry] = repriceCartEntries([cartEntry]);
        addItemToCart(repricedEntry);
        setPendingRecentItemNeedsReprice(false);
      } else {
        addItemToCart(cartEntry);
      }
    } else {
      setPendingRecentItem(cartEntry);
      setPendingRecentItemNeedsReprice(true);
      setStoreLocatorCallbackUrl(location.pathname);
      navigate(routes.storeLocator);
    }
  };

  const addToCart = () => {
    if (shouldShowSwitchToMobileDialog) {
      openSwitchCartMethod({ onConfirm: handleAddToCart });
    } else {
      handleAddToCart();
    }
  };

  return {
    addToCart,
    SwitchCartMethodDialog,
  };
};

export default useAddToCartRecentItem;
